import { render, staticRenderFns } from "./StartupUpdateLog.vue?vue&type=template&id=8f689eb6&scoped=true&"
import script from "./StartupUpdateLog.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupUpdateLog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f689eb6",
  null
  
)

export default component.exports